import type { ReactNode } from 'react';

export const symbol_water_bottle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M623-530H377q-5 14-13.46 25.5T343-485l32 345h250l32-345q-12-8-20.5-19.5T623-530ZM366-700l-17 69q9 8 16 18.5t11 22.5h248.58q4.64-11.43 11.03-21.71Q642-622 651-630l-17-70H366Zm9 620q-23.35 0-40.68-16Q317-112 315-135l-33-365q-1-8.89 3.5-16.44Q290-524 298-529l1-1q8-5 14-12t6-17q0-9-4-17t-12-12l-2-1q-9-5-13-14.5t-2-19.5l28-114q2-10 10.25-16.5T343-760h127v-60h-30q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h120q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-30v60h127q10.8 0 18.9 6.5Q684-747 686-737l27 112q2 10-2 19.5T698-591l-2 1q-8 4-12 12t-4 16.74q0 10.69 5.5 17.97 5.5 7.29 14.18 11.92t13.5 12.5Q718-511 717-501l-32 366q-2.25 23.36-19.5 39.18T625-80H375Zm125-450Zm0-60Z"
		/>
	</svg>
);
